import { Filter, FilterGroup } from "./index";

const callOwnerFilters: Filter[] = [{ label: "my calls only", value: "myCalls", checked: false }];

export const callOwnerGroup: FilterGroup = {
  title: "Call Owner",
  filters: callOwnerFilters,
  group: "callOwner",
};
